import SearchField from "../SearchField/SearchField";
import USPositionFormGroup from "./USPositionFormGroup";
import useUSPosition from "../../hooks/useUSPosition";
import { addEdits, handleProductSelect, handleInputSelect } from "./utils/inputhandlers";
import useUSUndo from "../../hooks/useUSUndo";

const PositionsUSAGeneral = ({ ignoreEnter, clearfield }) => {
  const { USposition, setUSposition, setUSpositionData, positiontoedit } = useUSPosition();
  const { positionEdits, editID, setEditID, undoList, inputRefs, setEditingField } = useUSUndo();

  return (
    <>
      {/* Position ID and Date */}
      <USPositionFormGroup readOnly={true} labelname={"PosID"} inputname={"USposID"} />
      <USPositionFormGroup readOnly={true} type={"date"} labelname={"Pos Date"} inputname={"posDate"} />
      {/* Purchase From Radio Buttons */}
      <fieldset>
        <legend>Purchase From:</legend>
        <div className='purchasefrom'>
          <div className='purchasefromform-group'>
            <label>
              <input
                name='purchaseFrom'
                type='radio'
                checked={USposition && USposition.purchaseFrom === 1 ? true : false}
                onClick={(e) => {
                  setUSposition((prev) => ({ ...prev, ["purchaseFrom"]: 1 }));
                  setUSpositionData((prev) => ({ ...prev, ["purchaseFrom"]: 1 }));
                  positionEdits.current.push({
                    editID: editID,
                    name: e.target.name,
                    value: 1,
                    num: 1,
                    figuretype: "radio",
                  });
                  setEditID((prev) => prev + 1);
                  setEditingField(false);
                  undoList.current = [];
                }}
                value={USposition.purchaseFrom}
                required
              />
              Supplier
            </label>
          </div>
          <div className='purchasefromform-group'>
            <label>
              <input
                name='purchaseFrom'
                type='radio'
                checked={USposition && USposition.purchaseFrom === 2 ? true : false}
                onClick={(e) => {
                  setUSposition((prev) => ({ ...prev, ["purchaseFrom"]: 2 }));
                  setUSpositionData((prev) => ({ ...prev, ["purchaseFrom"]: 2 }));
                  positionEdits.current.push({
                    editID: editID,
                    name: e.target.name,
                    value: 2,
                    num: 2,
                    figuretype: "radio",
                  });
                  setEditID((prev) => prev + 1);
                  setEditingField(false);
                  undoList.current = [];
                }}
                value={USposition.purchaseFrom}
                required
              />
              Intercompany
            </label>
          </div>
        </div>
      </fieldset>
      {/* Identifiers (WGPUS) */}
      <fieldset>
        <legend>Identifiers:</legend>
        <USPositionFormGroup labelname={"WGPUS"} inputname={"WGP"} inputtype={"integer"} cplaceholder={"WGPUS..."} />
      </fieldset>
      {/* General Information (Product, Supplier, Buyer) */}
      <fieldset>
        <legend>General:</legend>
        <div className='form-group'>
          <label>Product:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/positions/getprodsupplier'
            value={USposition?.product || ""}
            valueName='product'
            secondaryValueName='supplier'
            valueID='productID'
            style={{ width: "90%" }}
            customplaceholder='Select Product'
            onItemSelect={(item) => {
              handleProductSelect(
                item,
                setUSposition,
                setUSpositionData,
                positionEdits,
                addEdits,
                editID,
                setEditID,
                undoList
              );
            }}
            clearfield={clearfield}
          />
        </div>
        <div className='form-group'>
          <label>Supplier:</label>
          <input
            readOnly
            placeholder='Supplier...'
            onKeyDown={ignoreEnter}
            name={"supplierID"}
            value={USposition?.supplier || ""}
          />
        </div>
        <div className='form-group'>
          <label>Buyer:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/positions/getbuyers'
            value={USposition?.buyer || ""}
            valueName='buyer'
            valueID='buyerID'
            style={{ width: "90%" }}
            customplaceholder='Select Buyer'
            onItemSelect={(item) => {
              handleInputSelect(
                item,
                positionEdits,
                editID,
                setEditID,
                setUSposition,
                setUSpositionData,
                addEdits,
                undoList,
                "buyer",
                "buyer"
              );
            }}
            clearfield={clearfield}
          />
        </div>
      </fieldset>
    </>
  );
};

export default PositionsUSAGeneral;
